import { useState, useEffect } from 'react'

import { TYPES, DEFAULT_VALUE } from '../_config/constant'

const useResult = (props) => {
  const {
    value,
    defaultValue,
    onCancel,
    onConfirm,
  } = props
  const [result, setResult] = useState(value ?? defaultValue ?? DEFAULT_VALUE?.value)

  // 判断传入的 value 是否符合规则
  const isValidValue = (value = {} as any) => {
    const isValid = Array.isArray(value?.value) && TYPES.find(item => item.value === value?.type)
    return isValid
  }

  const handleConfirm = (value, type) => {
    // 不允许输入负数，-0 为 0
    value = value.map(item => Math.abs(item) + '')
    onConfirm?.({
      value,
      type
    })
    setResult({
      value,
      type
    })
  }

  const handleCancel = () => {
    onCancel?.()
  }

  useEffect(() => {
    if (!isValidValue(value)) return
    setResult(value)
  }, [value])

  return {
    result,
    handleConfirm,
    handleCancel
  }
}

export default useResult
